export const CHANGE_ALERT_CHANNEL = 'CHANGE_ALERT_CHANNEL';
export const RECEIVE_DEVICE_ALERTS = 'RECEIVE_DEVICE_ALERTS';
export const RECEIVE_DEVICE_MONITOR_CONFIG = 'RECEIVE_DEVICE_MONITOR_CONFIG';
export const RECEIVE_DEVICE_ISSUE_COUNTS = 'RECEIVE_DEVICE_ISSUE_COUNTS';
export const RECEIVE_LATEST_DEVICE_ALERTS = 'RECEIVE_LATEST_DEVICE_ALERTS';
export const SET_ALERT_LIST_STATE = 'SET_ALERT_LIST_STATE';
export const alertChannels = { email: 'email' };
